<div class="outer">
  <div class="container">
    <div class="label">
      <app-text-field [isAutoSize]="true" placeholderText="Question Label" [(model)]="label" (modelChange)="updateData()"></app-text-field>
    </div>
    <div class="option" *ngFor="let option of options; let i = index">
        <mat-radio-button disabled></mat-radio-button>
        <div>
            <input [(ngModel)]="option.label" (ngModelChange)="updateData()" placeholder="Option label" />
            <div class="value">
                <label>Value:</label>
                <input placeholder="#" [(ngModel)]="option.value" (ngModelChange)="updateData()" />
            </div>
        </div>
        <button class="rm-btn" (click)="removeOption(i)">-</button>
        <button class="add-btn" (click)="insertOptionAt(i)">+</button>
    </div>
  </div>
  <div class="container" *ngFor="let field of fields; let i = index">
    <div class="label-row">
      <div class="label-input">
        <app-text-field [isTextLimit]="false" [isAutoSize]="true" placeholderText="Label" [(model)]="field.label" (modelChange)="updateData()"></app-text-field>
      </div>
      <select [(ngModel)]="field.customs" (ngModelChange)="updateData()">
        <option [ngValue]="null" [defaultSelected]>-- Exclusion --</option>
        <option *ngFor="let exclusion of exclusions" [ngValue]="exclusion.id">{{ exclusion.name }}</option>
      </select>
      <app-button-secondary [imgUrl]="'assets/svg/minus-icon.svg'" [isGreen]="false" [isHoverGreen]="true" (click)="removeField(i)"></app-button-secondary>
      <app-button-secondary [imgUrl]="'assets/svg/plus-icon.svg'" [isGreen]="false" [isHoverGreen]="true" (click)="insertFieldAt(i)"></app-button-secondary>
      <app-button-secondary [imgUrl]="'assets/svg/arrow.svg'" [isGreen]="false" [isHoverGreen]="true" [disabled]="!canMoveFieldUp(i)" style="transform:rotate(180deg)" (click)="moveFieldUp(i)"></app-button-secondary>
      <app-button-secondary [imgUrl]="'assets/svg/arrow.svg'" [isGreen]="false" [isHoverGreen]="true" [disabled]="!canMoveFieldDown(i)" (click)="moveFieldDown(i)"></app-button-secondary>
    </div>
  </div>
</div>